<!--
	SEVEN GRID ROWS, in the same order as app-plan-card and app-enterprise-card:
	head (the card's own header), subtitle, price, price-note, volume, button,
	features. The page that puts these cards on a plans grid shares those rows,
	so the price, the volume selector and the "Talk to us" button of every card
	sit on the same lines. The subtitle and the note are empty rows here: they
	exist so this card and the Enterprise card line up.
-->
<lo-card [heading]="title" [headingLevel]="2">
	<p class="plan-sub"></p>

	<div class="api-price">
		@if (current) { @if (current.priceStruck) {
		<span class="price-struck lo-type-text-lg-semibold">
			${{ current.priceStruck }}
		</span>
		}
		<span class="price-value lo-type-display">
			${{ current.priceValue }}
		</span>
		<span class="price-meta lo-type-text-sm-semibold">
			{{ current.priceMeta }}
		</span>
		}
	</div>

	<p class="price-note"></p>

	<div class="api-volume">
		@if (current) {
		<lo-select
			label="Volume"
			size="sm"
			[options]="volumeOptions"
			[value]="'' + indexControl.value"
			[hint]="current.perUnitLabel"
			(valueChange)="onVolume($event)"
		></lo-select>
		}
	</div>

	<!--
		Self-serve CTA (Subscribe / Upgrade / Downgrade) — temporarily replaced by
		"Talk to us" (Influencer API is contact-sales for now). Restore this block to
		re-enable self-serve checkout.
	<button
		*ngIf="current"
		type="button"
		lo-button
		block
		[attr.data-action]="current.actionType"
		[disabled]="actionDisabled || current.actionDisabled"
		(click)="onAction()"
	>
		{{ current.actionLabel }}
	</button>
	-->

	<button
		lo-button
		variant="secondary"
		type="button"
		block
		(click)="onContact()"
	>
		Talk to us
	</button>

	<div class="api-body">
		@if (features.length > 0) {
		<ul class="api-features lo-type-text-sm">
			@for (feature of features; track feature) {
			<li class="row">
				<lo-icon name="check" [size]="12"></lo-icon>
				{{ feature }}
			</li>
			}
		</ul>
		}
	</div>
</lo-card>
